import { Component, Inject, OnInit } from '@angular/core';
import { DrawerRef, DRAWER_DATA_VAR } from 'mis-crystal-design-system/drawer';
import { DropdownItem } from 'mis-crystal-design-system/dropdown';
import { UtilService } from 'src/app/shared/services/util.service';
import { MyBookingsService } from '../../my-bookings/my-bookings.service';
import { parseZone } from 'moment';
import { DatePipe } from '@angular/common';
import { CommonService } from 'src/app/shared/services/common.service';
import { CommonBookingService } from '../../shared/common-booking.service';

@Component({
  selector: 'app-booking-single-details',
  templateUrl: './booking-single-details.component.html',
  styleUrls: ['./booking-single-details.component.scss']
})
export class BookingSingleDetailsComponent implements OnInit {

  public booking: any;
  public bookingSource: any;
  public bookingDestination: any;
  public noOfStops: any;
  public startTime: any; openD;
  public miscelleneousConfig: any;
  public ridersList: any;
  public showOtpProperty = false;
  documentList: any = [];
  dropdownData: DropdownItem[] = [
    { label: 'Edit', value: "1" },
    { label: 'Duplicate', value: "2" },
    { label: 'View Document', value: "3" },
    { label: 'View History', value: "4" },
    { label: 'Cancel', value: "5" },
  ];
  selectedItem: DropdownItem;
  passanger: any[] = [];
  marshall: any;
  multidayTrips: any[] = [];
  stopsDetails: any;

  travelPurposeConfig: any;
  reasonConfig: any;
  flightDetailsConfig: any;
  otherDetailsConfig: any;
  bookingFinalStatus: any;

  constructor(private drawerRef: DrawerRef,
              @Inject(DRAWER_DATA_VAR) private data: any,
              private utilService: UtilService, private datePipe: DatePipe,
              private myBookingService: MyBookingsService,
              private commonService: CommonService, private commonBookingSrv: CommonBookingService) {
    this.booking = data.data;
    this.miscelleneousConfig = data.miscelleneousConfig;
    this.showOtpProperty = data.showOtpProperty;
  }

  ngOnInit(): void {
    [this.travelPurposeConfig, 
      this.reasonConfig ,
      this.flightDetailsConfig, 
      this.otherDetailsConfig] = this.commonService.getTripDetailsEleConfig(['travelPurpose', 'reason', 'flightDetails', 'otherDetails'])
    if (this.booking.multiDayBooking) {
      this.multidayTrips.push(
        {
          day: 1,
          stops: this.booking.stops.map(item => ({
            address: item.address,
            geoArea: item.geoArea,
            time: item.time ? item.time : ''
          }))
        }
      );
      this.booking.multiDays.forEach(day => {
        this.multidayTrips.push({
          day: day.day,
          stops: day.stops.map(item => ({
            address: item.address,
            geoArea: item.geoArea
          }))
        });
      });
    }
    this.bookingFinalStatus = this.commonBookingSrv.getCabAllocationStatus(this.booking);
    this.stopsDetails = this.myBookingService.getStopsCompleteView(this.booking, this.miscelleneousConfig['12hrTimeFormat']);
    this.noOfStops = this.booking.stops.length;
    const ridersList = [];
    for (const stop of this.booking.stops) {
      if (Number(stop.priorityOrder) === 1) {
        this.bookingSource = stop;
      }
      if (Number(stop.priorityOrder) === this.noOfStops && this.noOfStops !== 1) {
        this.bookingDestination = stop;
      }
      for (const rider of stop.riders) {
        if (!ridersList.length) {
          ridersList.push(rider);
        } else {
          let riderExists = false;
          for (const newRider of ridersList) {
            if (newRider.personId === rider.personId) {
              riderExists = true;
              break;
            }
          }
          if (!riderExists) {
            ridersList.push(rider);
          }
        }
      }
    }
    this.ridersList = ridersList;
    this.startTime = this.getBookingTime(this.booking);

    this.myBookingService.fetchDocuments(this.booking.bookingId).subscribe(res => {
      this.documentList = Object.entries(res).slice(1).map(([filename, filesize]) => ({ filename, filesize }));
    });


    this.booking?.stops.forEach(stop => {
        stop?.riders.forEach(rider => {
          if (rider.riderType !== 'MARSHAL' && this.passanger.indexOf(rider) < 0 && rider.boardingType == "PickUp") {
            this.passanger.push(rider);
          }
          else if (rider.riderType === 'MARSHAL') {
          this.marshall = rider;
 }
        });
      });
  }

  getBookingTime(booking: any) {
    if (booking.startTime) {
      const dateMoment = this.utilService.getMoment(booking.startTime);
      return this.miscelleneousConfig['12hrTimeFormat'] === 'true' ?
        dateMoment.format('hh:mm A') : dateMoment.format('HH:mm');
    }
    return '--:--';
  }

  changeOption(event) {
    this.selectedItem = event;
    switch (event.value) {
      case '1': this.data.method('edit');
      case '2': this.data.method('duplicate');
      case '3': this.data.method('document');
      case '4': this.data.method('history');
      case '5': this.data.method('cancel');
      default:
    }
  }

  transformDate(date: string) {
    const dateString = parseZone(date, 'DD/MM/YYYY').format();
    return this.datePipe.transform(dateString, 'EEE, MMM dd');
  }
  OpenTrack() {
    this.data.method('track');
  }

  edit() {
    this.data.method('edit');
  }

  close() {
    this.drawerRef.close();
  }
}
